/* eslint-disable jsx-control-statements/jsx-use-if-tag */
/** @jsx jsx */
import { jsx } from 'theme-ui'
import { useMemo } from 'react'
import { BLOCKS as B } from '@contentful/rich-text-types'

import { RichText } from '../helpers/react'
import { getVariantPath } from '../../utils/get-variant-path'
import { getIcon } from '../../utils/icons'
import richTextFieldHasContent from '../../utils/rich-text-has-content'
import richTextStyles from '../helpers/rich-text-styles'
import { List as SparkList, ListItem as SparkListItem } from '@uswitch/spark.list'

import withComponentBase from '../helpers/with-component-base'

const filterEmptyTextContent = (content) =>
  content?.props?.children && !Array.isArray(content.props.children)
    ? filterEmptyTextContent(content.props.children)
    : !!(
        Array.isArray(content?.props?.children) &&
        content.props.children
          .join('')
          .trim()
          .replace(/(^,)|(,$)/g, '')
      )

const removeEmptyTextContent = (text) => text.filter(filterEmptyTextContent)

const stylePath = (field, variant) =>
  getVariantPath({
    atomicType: 'modules',
    componentId: 'checklist',
    variantName: variant,
    field,
  })

const styles = {
  'h1,h2,h3,h4,h5,h6': {
    marginTop: 'sm',
  },
  b: { fontWeight: 600 },
}

const parentContentTypeStyles = {
  textAlign: 'left',
  display: 'grid',
  width: 'auto',
  ...styles,
}

const createOptionOverride = (iconName, brand) => {
  const icon = getIcon(iconName, brand)

  return {
    renderNode: {
      [B.UL_LIST]: (_, text) => <SparkList>{text}</SparkList>,

      [B.LIST_ITEM]: (_, text) => (
        <If condition={removeEmptyTextContent(text).length}>
          <SparkListItem
            sx={{
              variant: stylePath('list-item', iconName),
            }}
            icon={icon?.icon}
            iconColor={icon?.color}
            className='Checklist__list-item'
          >
            {text}
          </SparkListItem>
        </If>
      ),
    },
  }
}

const Checklist = ({
  firstChecklistIcon,
  secondChecklistIcon,
  firstChecklist,
  secondChecklist = {},
  parentContentType,
  brand,
}) => {
  const firstOptionOverrides = useMemo(
    () => createOptionOverride(firstChecklistIcon, brand),
    [firstChecklistIcon],
  )
  const secondOptionOverrides = useMemo(
    () => createOptionOverride(secondChecklistIcon, brand),
    [secondChecklistIcon],
  )

  const secondChecklistExists = richTextFieldHasContent(secondChecklist)

  return (
    <div
      className='Checklist'
      sx={{
        gridTemplateColumns:
          parentContentType === 'richTextModule'
            ? ['1fr']
            : ['1fr', `repeat(${!secondChecklistExists ? 1 : 2},minmax(0,1fr))`],
        ...parentContentTypeStyles,
        variant: stylePath('container'),
      }}
    >
      <RichText
        content={firstChecklist.content}
        optionOverrides={firstOptionOverrides}
        style={{ variant: stylePath('list', firstChecklistIcon), ...richTextStyles }}
      />
      {secondChecklistExists && (
        <RichText
          content={secondChecklist?.content}
          optionOverrides={secondOptionOverrides}
          style={{ variant: stylePath('list', secondChecklistIcon), ...richTextStyles }}
        />
      )}
    </div>
  )
}

export default withComponentBase(Checklist, {
  withHeaderFooter: true,
})
